import { UserRole } from '../types/auth.types';
import {
  LayoutGrid, BookOpen, Map, Bot, Target, HelpCircle,
  Trophy, Crown, Medal, GraduationCap, Search,
  Settings, ShoppingBag, Sword, Users, Gamepad2, FileText
} from 'lucide-react';
import React from 'react';

export interface NavItem {
  path: string; label: string; icon: React.ElementType; roles?: UserRole[]; badge?: string;
}
export interface NavGroup { title?: string; items: NavItem[]; }

export const SIDEBAR_GROUPS: NavGroup[] = [
  {
    items: [
      { path:'/dashboard',        label:'Dashboard',        icon:LayoutGrid, roles:['student'] },
      { path:'/learning-journey', label:'Öğrenme Haritası', icon:Map,        roles:['student'] },
      { path:'/courses',          label:'Derslerim',        icon:BookOpen,   roles:['student'] },
      { path:'/notes',            label:'Notlarım',         icon:FileText,   roles:['student'] },
      { path:'/ai-mentor',        label:'AI Mentor',        icon:Bot,        roles:['student'] },
    ],
  },
  {
    title: 'OYUNLAŞTIRMA',
    items: [
      { path:'/games',        label:'Oyun Merkezi',     icon:Gamepad2,   roles:['student'], badge:'YENİ' },
      { path:'/leaderboard',  label:'Liderlik Tablosu', icon:Trophy,     roles:['student'] },
      { path:'/career-league',label:'Lig Sistemi',      icon:Crown,      roles:['student'] },
      { path:'/badges',       label:'Rozetlerim',       icon:Medal,      roles:['student'] },
      { path:'/coin-shop',    label:'Coin Mağazası',    icon:ShoppingBag,roles:['student'] },
    ],
  },
  {
    title: 'AI & GÖREVLER',
    items: [
      { path:'/adventure',   label:'Adventure Mode',  icon:Sword,      roles:['student'], badge:'HOT' },
      { path:'/hackathon',   label:'Hackathon',       icon:Trophy,     roles:['student'] },
      { path:'/code-review', label:'AI Kod İnceleme', icon:Search,     roles:['student'], badge:'PRO' },
      { path:'/projects',    label:'Projelerim',      icon:Target,     roles:['student'] },
      { path:'/quizzes',     label:'Quizler',         icon:HelpCircle, roles:['student'] },
    ],
  },
  {
    title: 'DİĞER',
    items: [
      { path:'/career',       label:'Kariyer Yolu',    icon:GraduationCap, roles:['student'] },
      { path:'/pricing',      label:'Premium',         icon:Crown,         roles:['student'] },
      { path:'/certificates', label:'Sertifikalarım',  icon:Medal,         roles:['student'] },
      { path:'/parent',       label:'Veli Paneli',     icon:Users,         roles:['parent'] },
      { path:'/settings',     label:'Ayarlar',         icon:Settings,      roles:['student','parent'] },
    ],
  },
];

// Sidebar'ın kullandığı fonksiyon - role göre filtrele
export function getSidebarGroups(role?: string) {
  return SIDEBAR_GROUPS.map(group => ({
    ...group,
    items: group.items.filter(item =>
      !item.roles || !role || item.roles.includes(role as UserRole)
    ),
  })).filter(group => group.items.length > 0);
}

// Navbar üst linkler (Navbar.tsx bunu kullanıyor)
export const TOP_NAV = [
  { path: '/learning-journey', label: '🗺️ Harita' },
  { path: '/courses',          label: '📚 Dersler' },
  { path: '/leaderboard',      label: '🏆 Sıralama' },
  { path: '/coin-shop',        label: '🪙 Mağaza' },
];
